/**
 * @generated SignedSource<<360b11f31cb2aed499cbf1a92211fdc8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AuthenticationTemplateQuery$variables = Record<PropertyKey, never>;
export type AuthenticationTemplateQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AuthenticationTemplate_query">;
};
export type AuthenticationTemplateQuery = {
  response: AuthenticationTemplateQuery$data;
  variables: AuthenticationTemplateQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthenticationTemplateQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AuthenticationTemplate_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AuthenticationTemplateQuery",
    "selections": [
      {
        "alias": "company",
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyDomainName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "features",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9892481faa2b9e2ebddab2be4042799a",
    "id": null,
    "metadata": {},
    "name": "AuthenticationTemplateQuery",
    "operationKind": "query",
    "text": "query AuthenticationTemplateQuery {\n  ...AuthenticationTemplate_query\n}\n\nfragment AuthenticationTemplate_query on Query {\n  company: companyDomainName {\n    id\n    name\n    features\n  }\n}\n"
  }
};

(node as any).hash = "e32d1f0d8302ffeec3d8f59d83c7b359";

export default node;
